import React from "react";
import { useTranslation } from "react-i18next";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import { trackSectionViewed, useSectionOnceObserver } from "../../lib/analytics";
import { WPS_SECTION } from "./sections.js";

/**
 * Questions about wedding photo sharing.
 *
 * Rendered as a plain definition list, always expanded — no accordion. Two
 * reasons: every answer is short enough to read in place, and collapsing them
 * behind a click would put the page's most self-contained factual passages
 * behind an interaction. They are ordinary visible copy for a reader, which is
 * also what makes them quotable.
 *
 * Every answer is checked against the current implementation. Notably: the QR
 * opens the JOIN page (not the uploader), guests never download other guests'
 * media, gallery availability is plan-dependent and the gallery closes when
 * the window ends (closes, never "deleted": nothing deletes it then, BACKLOG
 * AGP-018), and whole-collection archive download is a paid feature.
 */
const FAQ_KEYS = [
  "what",
  "howCollect",
  "app",
  "account",
  "videos",
  "qr",
  "private",
  "guestDownload",
  "coupleDownload",
  "howLong",
  "more",
];

const PhotoSharingFaq = () => {
  const { t } = useTranslation();

  const analyticsContext = useAnalyticsContext();

  // One impression the first time the section scrolls into view; the observer
  // disconnects itself afterwards.
  const sectionRef = useSectionOnceObserver(() =>
    trackSectionViewed(WPS_SECTION.FAQ, analyticsContext),
  );

  return (
    <section ref={sectionRef} className="section topless wps-section">
      <div className="container">
        <div className="wps-section-header">
          <h2 className="heading-50">{t("weddingPhotoSharing.faq.heading")}</h2>
        </div>

        <dl className="wps-faq">
          {FAQ_KEYS.map((key) => (
            <div key={key} className="wps-faq-item">
              <dt className="made-22 wps-faq-q">
                {t(`weddingPhotoSharing.faq.items.${key}.q`)}
              </dt>
              <dd className="wps-faq-a body-15">
                {t(`weddingPhotoSharing.faq.items.${key}.a`)}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default PhotoSharingFaq;
